"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByCriteria = exports.getClassBySortingCriteriaForProperty = exports.SortDirectionEnumerables = void 0;
var get_1 = __importDefault(require("lodash/get"));
var SortDirectionEnumerables;
(function (SortDirectionEnumerables) {
    SortDirectionEnumerables["ascending"] = "Ascending";
    SortDirectionEnumerables["descending"] = "Descending";
})(SortDirectionEnumerables || (exports.SortDirectionEnumerables = SortDirectionEnumerables = {}));
var getClassBySortingCriteriaForProperty = function (criteria, property) {
    if (criteria.property === property) {
        return criteria.direction === SortDirectionEnumerables.ascending ? 'asc' : 'desc';
    }
    return '';
};
exports.getClassBySortingCriteriaForProperty = getClassBySortingCriteriaForProperty;
var sortByCriteria = function (criteria) { return function (a, b) {
    var comparison = 0;
    var first = (0, get_1.default)(a, criteria.property);
    var second = (0, get_1.default)(b, criteria.property);
    if (typeof first === 'number' && typeof second === 'number') {
        comparison = first > second ? 1 : -1;
    }
    else if (first instanceof Date && second instanceof Date) {
        comparison = first.getTime() > second.getTime() ? 1 : -1;
    }
    else {
        first = first || '';
        second = second || '';
        comparison = first === null || first === void 0 ? void 0 : first.localeCompare(second, undefined, { numeric: true });
    }
    return criteria.direction === SortDirectionEnumerables.ascending ? comparison : comparison * -1;
}; };
exports.sortByCriteria = sortByCriteria;
